import * as z from 'zod/mini';
/**
 * Define a composite, patient-reported measurement (e.g. blood pressure) — several named numeric
 * components sharing one unit, each LOINC-coded, under one panel code.
 *
 * @__NO_SIDE_EFFECTS__
 */
export function defineCompositeMeasurement(options) {
    const valueShape = {};
    for (const key of Object.keys(options.components)) {
        valueShape[key] = z.number();
    }
    return {
        shape: 'composite',
        panelLoinc: options.panelLoinc,
        canonical: options.canonical,
        components: options.components,
        valueShape,
    };
}
//# sourceMappingURL=CompositeMeasurement.js.map